export default __webpack_public_path__ + "static/media/manwhowouldbeking.3b1291ca.png";